import { render, staticRenderFns } from "./ScaleProductsTitle.vue?vue&type=template&id=2f1422f2&scoped=true"
import script from "./ScaleProductsTitle.vue?vue&type=script&lang=js"
export * from "./ScaleProductsTitle.vue?vue&type=script&lang=js"
import style0 from "./ScaleProductsTitle.vue?vue&type=style&index=0&id=2f1422f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1422f2",
  null
  
)

export default component.exports